import { Block } from '@components/core-ui/Block';
import styled from 'styled-components';

export const StyledBlock = styled(Block)`
  padding-bottom: 20px;

  .leftSide {
    padding-right: 25px;
  }

  .rightSide {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .rightSide > * {
    margin-bottom: 0 !important;
  }
`;
